import React, { useState, useEffect } from 'react';
import { useNotification } from 'config/Notification';

import {
  Button,
  Autocomplete,
  TextField,

} from '@mui/material';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import Modal from 'react-bootstrap/Modal';

import { downloadReport as downloadReportService, fetchReports as fetchReportsService } from 'services/modules/ecs/report';
import { useSelector } from 'react-redux';

const ViewReport = ({ toggleViewReport }) => {
  // State variables
  const [loading, setLoading] = useState(false);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [show, setShow] = useState(true);
  const [error, setError] = useState('');
  const [reportsData, setReportsData] = useState([]);

  // Notification
  const { openNotification } = useNotification();

  // Redux Selector
  const authenticatedUserContainer = useSelector((state) => state.auth.user);

  // This method fetches all the report ids of completed status
  const fetchReportsData = async () => {
    setLoading(true);

    let params = {
      page: '1',
      limit: 20,
      sortBy: '-createdAt',
      reportStatus: 'COMPLETED',
    };
    try {
      const response = await fetchReportsService(params)
      if (response?.status === 200)
        setReportsData(response?.data)
      else
        openNotification(response)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // This method handles downloading the reports in excel format
  const handleDownloadExcel = async () => {
    try {
      if (!selectedReportId) {
        setError('Please select a report ID');
        return;
      }
      const response = await downloadReportService(selectedReportId);
      if (response.status === 200) {
        const fileUrl = response.data.url;
        window.open(fileUrl, '_blank');
        openNotification("Report Downloaded Successfully", "success")
      } else {
        openNotification(response, 'error');
      }
    } finally {
      setShow(false);
    }
  };

  // This method handles change in selected company
  const onInputChange = async (event, value, reason) => {
    if (value) {
      let params = {
        page: '1',
        limit: 20,
        sortBy: '-createdAt',
        search: value,
        reportStatus: 'COMPLETED',
      };
      if (value !== authenticatedUserContainer.company.name) {
        const response = await fetchReportsService(params)
        if (response?.status === 200)
          setReportsData(response?.data)
        else
          openNotification(response)
      }
    }
  }


  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="modal-90w"
      animation={false}
    >
      <Modal.Header className="space-between" closeButton>
        <Modal.Title className="report-modal">
          <LibraryBooksIcon className="m-1" />
          <h4 className="report-heading-1">Request excel report</h4>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="report-label mt-4">
          Receive an excel version of the report generated for your domain
        </h5>

        {loading ? (
          <div className="loader-container">
            <div className="spinner-border text-primary loader">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            <div className="report-modal-buttons d-flex justify-content-center align-items-center">
              <Autocomplete
                align="center"
                className="report-form"
                options={reportsData?.results || []}
                onInputChange={onInputChange}
                getOptionLabel={(option) => option?.reportId || ''}
                value={
                  reportsData?.results?.find((item) => item.id === selectedReportId) || null
                }
                onChange={(event, value) => {
                  if (value) {
                    setSelectedReportId(value.id);
                  } else {
                    setSelectedReportId(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="textfield"
                    label="Report Id"
                    variant="outlined"
                    size="small"
                    error={Boolean(error)}
                  />
                )}
                noOptionsText="No data found"
              />
            </div>
            <div className="report-modal-buttons">
              <Button variant="outlined" className="exel-button" onClick={handleDownloadExcel}>
                <LibraryBooksIcon className="m-1" /> Download excel
              </Button>
            </div>
          </>

        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewReport;
